import { ListItem } from '@mui/material';
import { forwardRef, useMemo } from 'react';
import { NavLink, Route } from 'react-router-dom';

export default function ListItemLink({ to, exact, children, ...props }: any) {
  const renderLink = useMemo(
    () =>
      forwardRef<any>((itemProps, ref) =>
        to.startsWith('http') ? (
          // eslint-disable-next-line jsx-a11y/anchor-has-content
          <a href={to} ref={ref} target="_blank" rel="noopener nofollower noreferrer" {...itemProps} />
        ) : (
          <NavLink exact={exact} to={to} ref={ref} {...itemProps} />
        )
      ) as any,
    [exact, to]
  );

  return (
    <Route exact={exact} path={to}>
      {({ match }) => {
        const selected = Boolean(match);
        return (
          <ListItem button component={renderLink} selected={selected} {...props}>
            {children}
          </ListItem>
        );
      }}
    </Route>
  );
}
